var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNebulizer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1173_54386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3674 10.6048C22.0888 10.0449 23.2973 8.42763 23.2973 6.51991V3.19915L20.2402 1.11973C19.4925 0.611133 18.5098 0.611133 17.7621 1.11973L14.7051 3.19915V6.51991C14.7051 8.43565 15.9024 10.0584 17.635 10.6118",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.001 4.49219C18.2464 4.49219 17.6348 5.10386 17.6348 5.85841V12.851H20.3672V5.85841C20.3672 5.10386 19.7555 4.49219 19.001 4.49219Z",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6348 7.65625H20.3672",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9374 3.83594H0.703125V12.5613H11.9374V3.83594Z",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0052 12.8693V15.5431C19.0052 19.8254 15.5327 23.2969 11.2492 23.2969C6.96566 23.2969 3.49316 19.8254 3.49316 15.5431V2.11388C3.49316 1.33477 4.12499 0.703125 4.90434 0.703125C5.68368 0.703125 6.31551 1.33477 6.31551 2.11388V3.83414",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.15234,
    cy: 6.48438,
    r: 0.703125,
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17676 12.5587V9.44922",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28613 12.5587V9.44922",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1173_54386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNebulizer);
export default __webpack_public_path__ + "static/media/nebulizer.86b0d2d094e8f928f275e1c8c30aa15e.svg";
export { ForwardRef as ReactComponent };